
<mat-accordion>
  <mat-expansion-panel  (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"  [expanded]="panelOpenState()" class="border">
<mat-expansion-panel-header *ngIf="showcdinfo" style="background: black; height: 50px;">
  <div class="container-fluid" style="background: black;display: flex;align-items: center;justify-content: space-between;">
     
     <h5 class="mb-0 text-white">Reducer Size
     </h5><i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
     <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
  </div>
 </mat-expansion-panel-header>

 <mat-expansion-panel-header *ngIf="showspinfo" style="background: #e2001a; height: 50px;">
  <div class="container-fluid" style="background: #e2001a;display: flex;align-items: center;justify-content: space-between;">
     
     <h5 class="mb-0 text-white">Reducer Size
     </h5><i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
     <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
  </div>
 </mat-expansion-panel-header>
 <div *ngIf="signalStatus==true">
    <div class="card">
        <div class="justify-content-center">
          <div class="row">
              <div class="col-md-6">
                  <table class="table table-bordered table-striped">
                      <thead class="thead-dark">
                        <tr>
                          <th scope="col" style="width: 300px;">Product Specifications</th>
                          <th scope="col">Imperial</th>
                          <th scope="col">Metric</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                            <td scope="row">Series</td>
                            <td id="series">B</td>
                            <td></td>
                        </tr>
                        <tr>
                          <td scope="row">Size Of Unit</td>
                          <td id="size">{{modifiedSize}}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td scope="row">Nominal Ratio</td>
                          <td id="ratio">{{specData.NominalRatio}}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td scope="row">Input Speed</td>
                          <td id="speed">{{specData.InputSpeed}}</td>
                          <td></td>
                        </tr>
                        
                        <tr>
                          <td scope="row">Output Speed</td>
                          <td id="speed">{{specData.OutputSpeed}}</td>
                          <td id="speed">{{specData.OutputSpeed}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Input Power Mechanical</td>
                          <td id="InpotPowerMechImp">{{specData.InputPowerMech}}</td>
                          <td id="InputPowerMech_Met">{{specData.InputPowerMech_Met}}</td>
                        </tr>
                        <tr>
                          <td scope="row">Input Power Thermal</td>
                          <td id="InputPowerThermalImp">{{specData.InputPowerTherm}}</td>
                          <td id="InputPowerThermal_Met">{{specData.InputPowerThermal_Met}}</td>
                        </tr>

                        <tr>
                          <td scope="row">Input Torque</td>
                          <td id="InputTorque_Imp">{{specData.InputTorque_Imp}}</td>
                          <td id="InputTorque_Met">{{specData.InputTorque_Met}}</td>
                        </tr>

                        <!-- <tr>
                          <td scope="row">Input Torque Acceleration</td>
                          <td id="InputTorqueAccel_Imp">{{specData.InputTorqueAccel_Imp}}</td>
                          <td id="InputTorqueAccel_Met">{{specData.InputTorqueAccel_Met}}</td>
                        </tr> -->




                        <tr>
                          <td scope="row">Output Torque</td>
                          <td id="OutputTorqueImp">{{specData.OutputTorque}}</td>
                          <td id="OutputTorque_Met">{{specData.OutputTorque_Met}}</td>
                        </tr>
                        <!-- <tr>
                          <td scope="row">Output Torque Acceleration</td>
                          <td id="OutputTorqueImp">{{specData.OutputTorqueAccel_Imp}}</td>
                          <td id="OutputTorque_Met">{{specData.OutputTorqueAccel_Met}}</td>
                        </tr> -->
                        <tr>
                          <td scope="row">Efficiency</td>
                          <td id="EfficiencyImp">{{specData.Effieciency}}</td>
                          <td id="EfficiencyImp">{{specData.Effieciency}}</td>
                        </tr>
                        <tr>
                          <td scope="row" class="bg-success sericeFactorStyle">SF Based on Mechanical Input Power</td>
                          <td class="bg-success sericeFactorStyle" id="specSF">{{ specData.specServiceFactor }}</td>
                          <td class="bg-success sericeFactorStyle" id="specSF"></td>
                        </tr>
                      </tbody>
                    </table>
              </div>
  
              <div class="col-md-6">
                <table class="table table-bordered table-striped">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col">User Inputs</th>
                        <th scope="col">Values</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td scope="row">Input Power</td>
                        <td>{{userSelectedData.SelectedInputPower}}</td>
                      </tr>
                      <tr>
                        <td scope="row">Units</td>
                        <td style="text-transform: capitalize;">{{userSelectedData.SelectedUnits}}</td>
                      </tr>
                      <tr>
                        <td scope="row">Input Speed</td>
                        <td>{{userSelectedData.SelectedSpeed}}</td>
                      </tr>
                      <tr>
                        <td scope="row">Ratio</td>
                        <td>{{userSelectedData.SelectedRatio}}</td>
                      </tr>
                      <tr>
                        <td scope="row">Duty Cycle &ge;50%</td>
                        <td style="text-transform: capitalize;">{{userSelectedData.SelectedDutyCycle}}</td>
                      </tr>
                      <tr>
                        <td scope="row">Min Required Service Factor</td>
                        <td>{{userSelectedData.SelectedServiceFactor}}</td>
                      </tr>
                      <tr>
                        <td scope="row">Output Speed</td>
                        <td>{{userSelectedData.SelectedOutputSpeed}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div id="divButtons" style="text-align: center;">
                    <div class="col-md-12">
                      <input id="Btn_largerSize" type="button" value="Larger Reducer" class="button m-1" (click)="largerReducer()">
                      <input id="Btn_smallerSize" type="button" value="Smaller Reducer" class="button m-1" (click)="smallerReducer()">
                      <input id="Btn_ChangeReducer" type="button" value="Change Reducer" class="button m-1" (click)="scrollToCommonSecondComponent()">
                    </div>
                    <div class="col-md-12">
                      <input id="Btn_ReducerSizeProceed" type="button" value="Proceed with Reducer Features" (click)="reducerFeature()" class="button btn btn-primary w-100 m-1 p-1" style="background-color: #59842b">
                    </div>
                    
                    </div>
                </div>
              
          </div>
          
          
            
      </div>
    </div>
    
</div>
<div *ngIf="signalStatus==false">
  <h4 style="color: red;">Please proceed from previous step</h4>
 </div>
</mat-expansion-panel>
